export const RECORDS = [
    { date: "12.09.2026", matches: [
        { teams: "Tottenham vs Everton", pick: "1", odds: 2.0, score: "FT 0:0" },
        { teams: "Atalanta vs Cagliari", pick: "1", odds: 1.65, score: "FT 1:2" }]},
    { date: "11.09.2026", matches: [
        { teams: "Admira vs Kapfenberg", pick: "1", odds: 1.8, score: "FT 1:0" },
        { teams: "Dukla Prague vs Vlasim", pick: "BTS-YES", odds: 1.65, score: "FT 3:1" }]},
    { date: "10.09.2026", matches: [
        { teams: "Radnik vs Crvena Zvezda", pick: "2/2", odds: 1.85, score: "HT 0:0 / FT 0:0" },
        { teams: "Falkenberg vs Oster", pick: "1", odds: 1.7, score: "FT 2:1" }]},
    { date: "09.09.2026", matches: [
        { teams: "Charlton vs QPR", pick: "X", odds: 3.2, score: "FT 0:0" },
        { teams: "HJK vs Inter Turku", pick: "1", odds: 2.4, score: "FT 2:1" }]},
    { date: "08.09.2026", matches: [
        { teams: "FC Porto vs Manchester City", pick: "2", odds: 1.7, score: "FT 0:2" },
        { teams: "Watford vs Preston", pick: "1", odds: 2.15, score: "FT 2:1" }]},
    { date: "07.09.2026", matches: [
        { teams: "Sabadell vs Cordoba", pick: "1", odds: 2.15, score: "FT 3:2" },
        { teams: "Istanbulspor AS vs Igdir FK", pick: "2", odds: 1.85, score: "FT 1:2" }]},
    { date: "06.09.2026", matches: [
        { teams: "Kocaelispor vs Samsunspor", pick: "1", odds: 2.3, score: "FT 1:0" },
        { teams: "Tychy vs Avia Swidnik", pick: "1", odds: 1.8, score: "FT 1:0" }]},
    { date: "05.09.2026", matches: [
        { teams: "Gijon vs Girona", pick: "2", odds: 2.45, score: "FT 0:2" },
        { teams: "Young Boys vs Luzern", pick: "Over 3.5", odds: 1.6, score: "FT 3:3" }]},
    { date: "04.09.2026", matches: [
        { teams: "Genoa vs Como", pick: "2", odds: 1.7, score: "FT 1:4" },
        { teams: "Altrincham vs Eastleigh", pick: "1", odds: 1.95, score: "FT 2:0" }]},
    { date: "03.09.2026", matches: [
        { teams: "Palermo vs Mantova", pick: "1", odds: 2.1, score: "FT 5:2" },
        { teams: "Toulouse vs Lille", pick: "2", odds: 2.1, score: "FT 0:1" }]},
    { date: "02.09.2026", matches: [
        { teams: "Salzburg vs SK Rapid", pick: "1", odds: 1.8, score: "FT 4:1" },
        { teams: "Udinese vs Venezia", pick: "1", odds: 1.7, score: "FT 2:1" }]},
    { date: "01.09.2026", matches: [
        { teams: "Al-Sadd vs Al-Gharafa", pick: "1", odds: 1.5, score: "FT 2:1" },
        { teams: "Sepsi Sf. Gheorghe vs CFR Cluj", pick: "Over 2.5", odds: 2.0, score: "FT 1:3" }]},
    { date: "31.08.2026", matches: [
        { teams: "Benfica vs Estoril", pick: "1/1", odds: 1.5, score: "1:0 / 2:1" },
        { teams: "Aston Villa vs Arsenal", pick: "2", odds: 1.6, score: "FT 0:1" }]},
    { date: "30.08.2026", matches: [
        { teams: "Rennes vs Le Mans", pick: "1", odds: 1.5, score: "FT 3:2" },
        { teams: "Al Qadsiah vs Al-Faisaly", pick: "1/1", odds: 1.7, score: "2:1 / 3:1" }]},
    { date: "29.08.2026", matches: [
        { teams: "Tottenham vs Newcastle", pick: "Over 2.5", odds: 1.7, score: "FT 0:2" },
        { teams: "FC Koln vs Hoffenheim", pick: "Over 2.5", odds: 1.65, score: "FT 3:2" }]},
    { date: "28.08.2026", matches: [
        { teams: "AFC Fylde vs Forest Green", pick: "Over 2.5", odds: 1.6, score: "FT 2:0" },
        { teams: "Legia vs Slask", pick: "1", odds: 1.5, score: "FT 1:1" }]},
    { date: "27.08.2026", matches: [
        { teams: "Chelsea vs Luton", pick: "1/1", odds: 1.6, score: "1:0 / 2:0" },
        { teams: "Lillestrom vs Egnatia", pick: "1", odds: 1.5, score: "FT 1:1" }]},
    { date: "26.08.2026", matches: [
        { teams: "Viking vs Dinamo Zagreb", pick: "BTS-YES", odds: 1.6, score: "FT 3:1" },
        { teams: "SK Rapid vs Hearts", pick: "1", odds: 1.6, score: "FT 1:1" }]},
    { date: "25.08.2026", matches: [
        { teams: "Ipswich vs Leicester", pick: "1", odds: 1.5, score: "FT 3:1" },
        { teams: "Peterhead vs Dundee FC B", pick: "1/1", odds: 1.5, score: "1:0 / 2:1" }]},
    { date: "24.08.2026", matches: [
        { teams: "Neom SC vs Al Qadsiah", pick: "2", odds: 1.6, score: "FT 0:2" },
        { teams: "Breidablik vs Fram", pick: "Over 3.5", odds: 1.8, score: "FT 3:4" }]},
];

export const combinedOdds = (r) => (r.matches[0].odds * r.matches[1].odds).toFixed(2);

export const TIPSTERS = [
    {
        id: "nikos-papadopoulos",
        name: "Nikos Papadopoulos",
        flag: "🇬🇷",
        country: "Greece",
        role: "Lead Analyst",
        focus: "Greek & Southern European leagues",
        img: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBFdXJvcGVhbiUyMG1hbiUyMHNwb3J0cyUyMGFuYWx5c3QlMjBwb3J0cmFpdCUyMGhlYWRzaG90fGVufDB8fHx8MTc4OTMwOTcwMnww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "georgios-nikolaidis",
        name: "Georgios Nikolaidis",
        flag: "🇬🇷",
        country: "Greece",
        role: "Odds & Market Specialist",
        focus: "Market movement & value pricing",
        img: "https://images.unsplash.com/photo-1623366302587-b38b1ddaefd9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBFdXJvcGVhbiUyMG1hbiUyMHNwb3J0cyUyMGFuYWx5c3QlMjBwb3J0cmFpdCUyMGhlYWRzaG90fGVufDB8fHx8MTc4OTMwOTcwMnww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "lukas-gruber",
        name: "Lukas Gruber",
        flag: "🇦🇹",
        country: "Austria",
        role: "Match Analyst",
        focus: "Austrian & Central European leagues",
        img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBFdXJvcGVhbiUyMG1hbiUyMHNwb3J0cyUyMGFuYWx5c3QlMjBwb3J0cmFpdCUyMGhlYWRzaG90fGVufDB8fHx8MTc4OTMwOTcwMnww&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "felix-schneider",
        name: "Felix Schneider",
        flag: "🇩🇪",
        country: "Germany",
        role: "Data & Tactics Analyst",
        focus: "Bundesliga & German football",
        img: "https://images.unsplash.com/photo-1652471943570-f3590a4e52ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxtYWxlJTIwc3BvcnRzJTIwYW5hbHlzdCUyMGhlYWRzaG90JTIwcG9ydHJhaXQlMjBleGVjdXRpdmV8ZW58MHx8fHwxNzg5MzA5NzEwfDA&ixlib=rb-4.1.0&q=85",
    },
    {
        id: "anders-johansen",
        name: "Anders Johansen",
        flag: "🇳🇴",
        country: "Norway",
        role: "Match Analyst",
        focus: "Nordic & Scandinavian leagues",
        img: "https://images.unsplash.com/photo-1600878459138-e1123b37cb30?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxtYWxlJTIwc3BvcnRzJTIwYW5hbHlzdCUyMGhlYWRzaG90JTIwcG9ydHJhaXQlMjBleGVjdXRpdmV8ZW58MHx8fHwxNzg5MzA5NzEwfDA&ixlib=rb-4.1.0&q=85",
    },
];

export const PLANS = [
    { id: "2-doubles", name: "2 DOUBLES", price: 50, per: "€25.00 / double", recommended: false },
    { id: "10-doubles", name: "10 DOUBLES", price: 150, per: "€15.00 / double", recommended: true },
    { id: "20-doubles", name: "20 DOUBLES", price: 250, per: "€12.50 / double", recommended: false },
    { id: "30-doubles", name: "30 DOUBLES", price: 350, per: "€11.67 / double", recommended: false },
];

export const SINGLES_PLANS = [
    { id: "2-singles", name: "2 SINGLES", price: 30, per: "€15.00 / single", recommended: false },
    { id: "10-singles", name: "10 SINGLES", price: 100, per: "€10.00 / single", recommended: true },
    { id: "20-singles", name: "20 SINGLES", price: 180, per: "€9.00 / single", recommended: false },
    { id: "30-singles", name: "30 SINGLES", price: 250, per: "€8.33 / single", recommended: false },
];

export const SINGLES = [
    { date: "12.09.2026", teams: "Southampton vs Bristol City", pick: "BTS & 3+", odds: 2.05, score: "FT 4:1", status: "won" },
    { date: "11.09.2026", teams: "Dijon vs Laval", pick: "3+", odds: 2.1, score: "FT 3:2", status: "won" },
    { date: "10.09.2026", teams: "Stevenage vs Luton", pick: "BTS & 3+", odds: 2.05, score: "FT 2:1", status: "won" },
    { date: "09.09.2026", teams: "Norwich vs Birmingham", pick: "BTS & 3+", odds: 2.25, score: "FT 2:1", status: "won" },
    { date: "08.09.2026", teams: "Watford vs Preston", pick: "3+", odds: 2.0, score: "FT 2:1", status: "won" },
    { date: "07.09.2026", teams: "Athens Kallithea vs Niki Volos", pick: "3+", odds: 2.88, score: "FT 2:1", status: "won" },
    { date: "06.09.2026", teams: "Beveren vs Leuven", pick: "1", odds: 2.05, score: "FT 3:0", status: "won" },
    { date: "05.09.2026", teams: "Preston vs Blackburn", pick: "3+", odds: 2.1, score: "FT 2:1", status: "won" },
    { date: "04.09.2026", teams: "Grenoble vs Annecy", pick: "3+", odds: 2.4, score: "FT 1:2", status: "won" },
    { date: "03.09.2026", teams: "—", pick: "—", odds: null, score: "—", status: "nomatch" },
    { date: "02.09.2026", teams: "Burton vs AFC Wimbledon", pick: "3+", odds: 2.1, score: "FT 4:1", status: "won" },
    { date: "01.09.2026", teams: "Preston vs Bristol City", pick: "3+", odds: 2.0, score: "FT 1:3", status: "won" },
    { date: "31.08.2026", teams: "Boston Utd vs Hornchurch", pick: "BTS & 3+", odds: 2.2, score: "FT 2:3", status: "won" },
    { date: "30.08.2026", teams: "Mansfield vs Luton", pick: "BTS & 3+", odds: 2.1, score: "FT 5:2", status: "won" },
    { date: "29.08.2026", teams: "Hebburn Town vs King's Lynn", pick: "BTS & 3+", odds: 2.05, score: "FT 4:2", status: "won" },
    { date: "28.08.2026", teams: "Laval vs Grenoble", pick: "3+", odds: 2.1, score: "FT 0:3", status: "won" },
    { date: "27.08.2026", teams: "—", pick: "—", odds: null, score: "—", status: "nomatch" },
    { date: "26.08.2026", teams: "Asane vs Lyn", pick: "2", odds: 2.35, score: "FT 1:2", status: "won" },
    { date: "25.08.2026", teams: "Unirea Slobozia vs Metaloglobus Bucharest", pick: "3+", odds: 2.1, score: "FT 1:2", status: "won" },
    { date: "24.08.2026", teams: "Reims vs Annecy", pick: "3+", odds: 2.11, score: "FT 3:1", status: "won" },
];

export const PAYMENT_METHODS = [
    { id: "paypal", name: "PayPal", tag: "Fast & secure", note: "Send the plan amount via PayPal. Our PayPal address is emailed to you right after you confirm your order." },
    { id: "skrill", name: "Skrill", tag: "Popular with bettors", note: "Send the plan amount via Skrill. Our Skrill account is emailed to you right after you confirm your order." },
    { id: "neteller", name: "Neteller", tag: "Popular with bettors", note: "Send the plan amount via Neteller. Our Neteller account is emailed to you right after you confirm your order." },
    { id: "wise", name: "Wise", tag: "Low-fee transfer", note: "Send the plan amount via Wise. Our Wise details (email / IBAN) are emailed to you right after you confirm your order." },
    { id: "revolut", name: "Revolut", tag: "Instant transfer", note: "Send the plan amount via Revolut. Our Revolut tag is emailed to you right after you confirm your order." },
    { id: "crypto", name: "Crypto (USDT)", tag: "TRC20 / ERC20", note: "Send the plan amount in USDT. Our wallet address (TRC20 or ERC20) is emailed to you right after you confirm your order." },
    { id: "bank", name: "Bank Transfer", tag: "SWIFT / SEPA", note: "Send the plan amount by bank transfer. Our IBAN and bank details are emailed to you right after you confirm your order." },
    { id: "western-union", name: "Western Union", tag: "Worldwide", note: "Send the plan amount via Western Union. The receiver name and details are emailed to you right after you confirm your order." },
    { id: "ria", name: "Ria Money", tag: "Worldwide", note: "Send the plan amount via Ria Money Transfer. The receiver name and details are emailed to you right after you confirm your order." },
];

export const HERO_IMG = "https://images.unsplash.com/photo-1517927033932-b3d18e61fb3a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxmb290YmFsbCUyMG1hdGNoJTIwc3RhZGl1bSUyMGFjdGlvbiUyMGJsdWUlMjBsaWdodGluZ3xlbnwwfHx8Ymx1ZXwxNzg5MzA5NzAyfDA&ixlib=rb-4.1.0&q=85";
export const HERO_BG = "https://images.unsplash.com/photo-1487466365202-1afdb86c764e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxmb290YmFsbCUyMG1hdGNoJTIwc3RhZGl1bSUyMGFjdGlvbiUyMGJsdWUlMjBsaWdodGluZ3xlbnwwfHx8Ymx1ZXwxNzg5MzA5NzAyfDA&ixlib=rb-4.1.0&q=85";
